import { render, staticRenderFns } from "./ElList.vue?vue&type=template&id=6baec0c1"
import script from "./ElList.vue?vue&type=script&lang=js"
export * from "./ElList.vue?vue&type=script&lang=js"
import style0 from "./ElList.vue?vue&type=style&index=0&id=6baec0c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports